(function () {
  angular.module("akitabox.ui.dialogs.note", [
    "akitabox.ui.dialogs.note.delete",
  ]);
})();
